// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"SignUp_scroll-black__bvZiQ","input-columns":"SignUp_input-columns__8gWV1","terms-checkbox":"SignUp_terms-checkbox__11EYV"};